import React, {useEffect, useRef} from 'react';
import lottie from 'lottie-web/build/player/lottie_light';
import type {AnimationItem} from 'lottie-web';

type LottiePlayerConfig = {path: string};

interface LottieProps {
  config: LottiePlayerConfig;
  className?: string;
}

export function Lottie({config, className}: LottieProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const animationRef = useRef<AnimationItem | null>(null);

  useEffect(() => {
    if (!containerRef.current) {
      return undefined;
    }

    animationRef.current = lottie.loadAnimation({
      loop: true,
      autoplay: true,
      ...config,
      container: containerRef.current,
      renderer: `svg`,
    });

    return () => {
      animationRef.current?.destroy();
      animationRef.current = null;
    };
  }, [config]);

  return (
    <div className={className} style={{display: `block`}}>
      <div ref={containerRef} />
    </div>
  );
}
